export default {
    NODOKTER: 'Dokter Tidak Tersedia',
    DELETEJADWAL: 'Jadwal Tidak Tersedia',
    DIFFDURATION: 'Durasi Yang Tersedia Berbeda',
    DIFFDATE: 'Tanggal Tidak Tersedia',
    DOKTERCUTI: 'Dokter Cuti',
    WAITINGLISTDEFECT: "Waiting List Defect",
    NOSLOTJADWAL: 'Jam Kunjungan Tidak Tersedia',
    NOJADWAL: 'Jadwal Tidak Ditemukan',
    CLASS_CANCEL: ['need-confirmation', 'dismiss-card']
}